import { render, staticRenderFns } from "./addTest.vue?vue&type=template&id=bd1e16e4&scoped=true&"
import script from "./addTest.vue?vue&type=script&lang=js&"
export * from "./addTest.vue?vue&type=script&lang=js&"
import style0 from "./addTest.vue?vue&type=style&index=0&id=bd1e16e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1e16e4",
  null
  
)

export default component.exports